import { RequireOnly } from '@pelicargo/types';
import { Backlog, BacklogStatus } from '@prisma/client';

import { prettyDate } from '../../formatter';

export const getBacklogStatus = (backlogs?: RequireOnly<Backlog, 'status' | 'next_flight_at'>[]) => {
  if (!backlogs?.length) return null;
  const atRisk = backlogs.find((b) => b.status === BacklogStatus.AtRisk);
  const backlogged = backlogs.find((b) => b.status === BacklogStatus.Backlogged);

  if (backlogged && backlogged.next_flight_at) {
    return `Backlogged until ${prettyDate(backlogged.next_flight_at)}`;
  }
  if (backlogged) {
    return 'Backlogged';
  }
  if (atRisk) {
    return `Backlog Risk`;
  }
  return null;
};
